import { useLocation, useNavigate } from 'react-router';

import { useCurrentUserContext } from '#src/contexts/currentUser/index.ts';
import {
  WalletTab,
  useWalletDrawerContext,
} from '#src/contexts/walletDrawer/index.tsx';
import { useQueryString } from '#src/hooks/useQueryString.ts';

export const usePromptAddFunds = () => {
  const { currentUser } = useCurrentUserContext();

  const { showDrawer, mounted, setCurrentTab, currentTab } =
    useWalletDrawerContext();
  const action = useQueryString('action');
  const location = useLocation();
  const navigate = useNavigate();

  if (
    action !== 'addFunds' ||
    !mounted ||
    !currentUser ||
    currentTab === WalletTab.ADD_FUNDS
  ) {
    return;
  }
  setCurrentTab(WalletTab.HOME);
  showDrawer();

  navigate(location.pathname, { replace: true });
};
